import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { Element } from 'react-scroll';
import CountOfTotal from '../../../../components/CountOfTotal';
import InputForm from '../../../../components/form/InputForm';
import SelectForm from '../../../../components/form/SelectForm';
import TextAreaForm from '../../../../components/form/TextAreaForm';
import DateRangePickerForm from '../../../../components/form/DateRangePickerForm';
import ImageAndVideoUploadForm from '../../../../components/form/ImageAndVideoUploadForm';
import { formRequiredRules } from '../../../../lib/formRules';
import moment, { setDateFormat } from '../../../../lib/moment';
import { Attachment } from '../../../../components/input/ImageAndVideoUploadV2/types';
import { DateRange } from '../../../../components/form/DateRangePickerForm/DateRangePickerForm';
import { EventStatus } from '../types';
import {
  EVENT_STATUS_SELECT_LIST_V2,
  EVENT_STATUS_V2,
  MAXIMUM_NUMBER_OF_EVENT_CONTENT_TEXT,
  MAXIMUM_NUMBER_OF_EVENT_MAIN_TITLE_TEXT,
  MAXIMUM_NUMBER_OF_EVENT_MEMO_TEXT,
  MAXIMUM_NUMBER_OF_EVENT_SEARCH_IMG,
  PLACEHOLDER_TEXT_EVENT_PERIOD_DATE,
} from '../../../../constants/service/app/eventConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './EventSaveInfo.scss';

type Status = (typeof EVENT_STATUS_V2)[keyof typeof EVENT_STATUS_V2];
interface EventSaveInfoProps extends FormComponentProps {
  mainTitle: string | null;
  status: EventStatus;
  contents: string | null;
  memo: string | null;
  period: DateRange;
  eventAttachmentList: Attachment[];
}
const EventSaveInfo = (props: EventSaveInfoProps) => {
  const { form, mainTitle, status, contents, memo, period, eventAttachmentList } = props;

  const fieldsValue = form.getFieldsValue(['mainTitle', 'status', 'contents', 'memo']);

  const onChangeEventStatus = (value: EventStatus) => {
    const period = form.getFieldValue('period');

    // 무기한 기획전 상태에서 상태가 변경되거나 기획전 기간이 없을 경우, 초기값 세팅
    if (value === EVENT_STATUS_V2.UNLIMITED) return;
    else if (period && period.startDate !== '-' && period.endDate !== '-') return;

    form.setFieldsValue({
      period: {
        startDate: setDateFormat(moment(), DATE_FORMAT.YMD_HM_DASH_FORMAT),
        endDate: setDateFormat(moment().add(7, 'day'), DATE_FORMAT.YMD_HM_DASH_FORMAT),
      },
    });
  };

  return (
    <Element name="event-info">
      <div className="event-save-info">
        <div className="title">기획전 정보</div>

        {/*기획전 제목*/}
        <InputForm
          className="main-title"
          form={form}
          label={
            <span>
              기획전 제목
              <CountOfTotal content={fieldsValue.mainTitle} maxCnt={MAXIMUM_NUMBER_OF_EVENT_MAIN_TITLE_TEXT} />
            </span>
          }
          rules={[formRequiredRules(true, '기획전 제목을 입력해주세요.')]}
          initialValue={mainTitle}
          maxLength={MAXIMUM_NUMBER_OF_EVENT_MAIN_TITLE_TEXT}
          name="mainTitle"
        />

        {/*기획전 상태*/}
        <SelectForm
          label="기획전 상태"
          form={form}
          initialValue={status}
          list={EVENT_STATUS_SELECT_LIST_V2}
          onChange={onChangeEventStatus}
          name="status"
        />

        {/*기획전 기간*/}
        {fieldsValue.status !== EVENT_STATUS_V2.UNLIMITED && (
          <DateRangePickerForm
            form={form}
            label="기획전 기간"
            name="period"
            initialValue={period}
            showTime={true}
            startText={PLACEHOLDER_TEXT_EVENT_PERIOD_DATE}
            endText={PLACEHOLDER_TEXT_EVENT_PERIOD_DATE}
            outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
            format={DATE_FORMAT.FULL_DASH_FORMAT}
            subContent={
              <div className="sub-info">
                <div>기획전 내용이 활성화되는 기간입니다.</div>
              </div>
            }
          />
        )}

        {/*기획전 본문*/}
        <TextAreaForm
          form={form}
          label={
            <span>
              기획전 본문
              <CountOfTotal content={fieldsValue.contents} maxCnt={MAXIMUM_NUMBER_OF_EVENT_CONTENT_TEXT} />
            </span>
          }
          rules={[formRequiredRules(true, '기획전 본문을 입력해주세요.')]}
          initialValue={contents}
          maxLength={MAXIMUM_NUMBER_OF_EVENT_CONTENT_TEXT}
          name="contents"
          rows={5}
        />

        {/*기획전 메모*/}
        <TextAreaForm
          form={form}
          label={
            <span>
              기획전 메모
              <CountOfTotal content={fieldsValue.memo} maxCnt={MAXIMUM_NUMBER_OF_EVENT_MEMO_TEXT} />
            </span>
          }
          rules={[formRequiredRules(true, '메모를 입력해주세요.')]}
          initialValue={memo}
          maxLength={MAXIMUM_NUMBER_OF_EVENT_MEMO_TEXT}
          name="memo"
          rows={5}
        />

        {/*검색 시 노출되는 이미지*/}
        <ImageAndVideoUploadForm
          form={form}
          label="검색 시 노출되는 이미지"
          rules={[formRequiredRules(true, '필수 정보입니다.', false, 'array')]}
          name="eventAttachment"
          initialValue={eventAttachmentList}
          modalTitle="검색 시 노출되는 이미지"
          maxCnt={MAXIMUM_NUMBER_OF_EVENT_SEARCH_IMG}
          cropMode={false}
          subContent="기획전 검색 시 노출 되는 기획전 이미지 정보를 입력해주세요"
        />
      </div>
    </Element>
  );
};

EventSaveInfo.displayName = 'EventSaveInfo';

export default EventSaveInfo;
